<template>
    <v-server-table
        :url="apiUrl"
        :filterable="filterable"
        :options="options"
        v-bind="$attrs"
        class="trigger"
        ref="table"
        @row-click="handleRowClick"
    >
        <template slot="name" slot-scope="props">
            <link-if
                :if="$can('view-relations')"
                :to="{ name: 'admin.relations.view', params: { id: props.row.relation_id } }"
            >
                {{ $getIfExists(props, ['row', 'relation', 'full_name']) }}
            </link-if>
        </template>
        <template slot="city" slot-scope="props">
            <div
                class="pointer"
                v-if="$getIfExists(props, ['row', 'relation', 'addresses', 0, 'city'], false)"
                @click.stop="tooltip(props.row.relation.addresses[0])"
            >
                <span>
                    {{ props.row.relation.addresses[0].city }}
                    <i class="fa fa-info-circle" aria-hidden="true"></i>
                </span>
                <!-- todo: Implement the entire thomas tip please -->
                <div class="thomastip" v-if="showToolTip(props.row.relation.addresses[0])">
                    <address-helper :address="props.row.relation.addresses[0]"></address-helper>
                </div>
            </div>
            <span v-else>{{ uLang('app.no_address') }}</span>
        </template>
        <template slot="status" slot-scope="props">
            {{ $getIfExists(props, ['row', 'trajectory_enrolment_status', 'translated_name']) }}
        </template>
        <template slot="active" slot-scope="props">
            {{
                $getIfExists(props, ['row', 'relation', 'active'], false) ? uLang('app.active') : uLang('app.inactive')
            }}
        </template>
        <template slot="filter__status">
            <multi-select
                :options="statuses"
                :loading="!statuses"
                :deselectLabel="uLang('app.press_enter_to_remove')"
                :selectLabel="uLang('app.press_enter_to_select')"
                :selectedLabel="uLang('app.select')"
                label="translated_name"
                :placeholder="uLang('app.select_an_option')"
                @input="searchStatus"
                track-by="name"
            />
        </template>
        <template slot="filter__active">
            <multi-select
                :options="[
                    {'value': 1, 'name': uLang('app.active') },
                    {'value': 0, 'name': uLang('app.inactive') },
                ]"
                :deselectLabel="uLang('app.press_enter_to_remove')"
                :selectLabel="uLang('app.press_enter_to_select')"
                :selectedLabel="uLang('app.select')"
                label="name"
                :placeholder="uLang('app.select_an_option')"
                @input="searchActive"
                track-by="name"
            />
        </template>
    </v-server-table>
</template>

<script>
    import MultiSelect from 'vue-multiselect/src/index'
    import { TableMixin, TooltipMixin } from '~/mixins'
    import { ErrorAlert } from '~/Swals'

    export default {
        name: 'ClientTrajectoryEnrolmentTable',
        mixins: [TableMixin, TooltipMixin],
        components: {
            'multi-select': MultiSelect,
        },

        props: {
            apiUrl: {
                type: String,
                required: true,
                default: null,
            },
        },

        data() {
            return {
                statuses: [],
                filterable: [
                    'name',
                    'city',
                ],
                options: {
                    headings: {
                        name: this.uLang('app.name'),
                        city: this.uLang('app.address'),
                        status: this.uLang('app.status'),
                        active: this.uLang('app.active'),
                    },
                    requestFunction(data) {
                        const router = this.$router

                        return axios.get(this.url, {
                            params: data
                        }).catch(function ({ response, message }) {
                            if (response && response.status === 403) {
                                router.push({ name: '403' })
                            }

                            new ErrorAlert({
                                title: uLang('app.oops_something_went_wrong'),
                                text: message,
                            }).show();
                        });
                    }
                },
            };
        },

        created() {
            this.retrieveStatuses();
        },

        methods: {
            async retrieveStatuses() {
                const { data } = await window.axios.get(route('trajectory-enrolment-statuses.index'));
                this.statuses = data;
            },

            searchStatus(status) {
                this.$refs.table.query.status = status !== null ? status.name : '';
                this.$refs.table.refresh();
            },

            searchActive(active) {
                this.$refs.table.query.active = active !== null ? active.value : '';
                this.$refs.table.refresh();
            },

            handleRowClick(clickEvent) {
                this.$router.push({
                    name: 'admin.relations.view',
                    params: {
                        id: clickEvent.row.relation_id,
                    }
                })
            },
        },
    }
</script>

<style lang="css" scoped>
</style>
